import script from "./StatementHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./StatementHistory.vue?vue&type=script&setup=true&lang=js"

import "./StatementHistory.vue?vue&type=style&index=0&id=63fd1a90&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63fd1a90"]])

export default __exports__